/*
 * Format date timestamp in 12hr format, e.g. 8.01am, 11.34pm.
 */
export const formatDateTime = (timestamp) => {
  const date = new Date(timestamp);
  let hour = date.getUTCHours();
  let minute = date.getUTCMinutes();
  const amPM = (hour > 11) ? 'pm' : 'am';
  if (hour > 12) {
    hour -= 12;
  } else if (hour === 0) {
    hour = '12';
  }
  if (minute < 10) {
    minute = `0${minute}`;
  }
  return `${hour}.${minute}${amPM}`;
};

/**
 * Format numbers as ordinals, e.g. 1st, 2nd, 3rd, 4th.
 */
export const formatDateOrdinal = (num) => {
  if (num > 3 && num < 21) {
    return 'th';
  }
  switch (num % 10) {
    case 1:
      return 'st';
    case 2:
      return 'nd';
    case 3:
      return 'rd';
    default:
      return 'th';
  }
};

/**
 * Format month as abbreviated, e.g. Jan, Feb, Mar.
 */
export const formatDateMonth = (timestamp) => {
  const date = new Date(timestamp);
  const month = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'][date.getUTCMonth()];
  return month;
};

/**
 * Format date timestamp to 22nd Nov or 22nd Nov 2003.
 * Year is shown if the date is in the past, or the year is a future year.
 */
export const formatDateLong = (timestamp, currentDate = new Date() /* Set date for tests */) => {
  const date = new Date(timestamp);
  const year = date.getUTCFullYear();
  const month = formatDateMonth(timestamp);
  const day = date.getUTCDate();
  return `${day}${formatDateOrdinal(day)} ${month} ${date < currentDate || year > currentDate.getUTCFullYear() ? year : ''}`.trim();
};

/**
 * Format date timestamp to 22/11/2003.
 */
export const formatDateShort = (timestamp) => {
  const date = new Date(timestamp);
  const year = date.getUTCFullYear();
  const month = date.getUTCMonth() + 1;
  const day = date.getUTCDate();
  return `${day < 10 ? `0${day}` : day}/${month < 10 ? `0${month}` : month}/${year}`;
};

/**
 * Format date timestamp to 22/11/03.
 */
export const formatDateShorter = (timestamp) => {
  const date = new Date(timestamp);
  const year = date.getUTCFullYear().toString().slice(2);
  const month = date.getUTCMonth() + 1;
  const day = date.getUTCDate();
  return `${day < 10 ? `0${day}` : day}/${month < 10 ? `0${month}` : month}/${year}`;
};

/**
 * Format number to string with commas and four decimal places by default.
 */
export const formatNumber = (num, options = { minimumFractionDigits: 0, maximumFractionDigits: 4 }) => num.toLocaleString('en', options);

/**
 * Format prices to two decimal places, unless round.
 */
export const formatPrice = (symbol, value, numericalZero) => {
  const float = parseFloat(value);
  const formatted = float === parseInt(float, 10)
    ? formatNumber(float)
    : formatNumber(float, { minimumFractionDigits: 2 });
  if (float === 0 && !numericalZero) {
    return 'Free';
  }
  return `${symbol}${formatted}`;
};



// WEBPACK FOOTER //
// ./app/src/utils/formats.js